/**
 * Reads a JSON value saved in browser storage. A damaged value (half-written,
 * changed by an extension, an older shape) must never stop the app from
 * starting: it is removed and the fallback is used.
 */
export const readJson = <T>(
  key: string,
  fallback: T,
  validate?: (value: unknown) => value is T,
  storage: Storage = localStorage
): T => {
  let raw: string | null;
  try {
    raw = storage.getItem(key);
  } catch {
    return fallback; // Storage blocked (privacy settings): nothing to read.
  }
  if (raw === null) return fallback;
  try {
    const value: unknown = JSON.parse(raw);
    if (!validate || validate(value)) return value as T;
  } catch {
    /* not JSON: removed below */
  }
  try {
    storage.removeItem(key);
  } catch {
    /* ignore */
  }
  return fallback;
};
